import cashierApis from 'modules/POS/services/apis';
import { useState } from 'react';
import { IResponseData } from 'services/response';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { cashierCtrl } from '../../cashier.controller';
import CashierActionButton from '../../components/CashierActionButton';
import ModalInputReasonVoid from './ModalReason';
import { useSocketContext } from '../../hooks/useSocket';
type Props = {
  value?: string;
  useForMultiCards?: boolean;
  onDone?: () => void;
};
const CashierVoidTicket = ({ value: billId, useForMultiCards, onDone = () => undefined }: Props) => {
  const [visible, setVisible] = useState(false);
  const onClose = () => setVisible(false);
  const onVoidTicket = () => setVisible(true);
  const socket = useSocketContext();

  const handleVoidTicket = async (note: string) => {
    if (!billId) return;
    setPageLoading(true);
    try {
      const res: IResponseData<boolean> = await cashierApis.voidOpenTicket({ billId, note });
      if (res.data.data) {
        toast.success('Success!');
        cashierCtrl.generateNewTicket();
        socket.backToCheckIn();
        onDone();
      }
    } catch (error) {
    } finally {
      setPageLoading(false);
    }
  };
  return (
    <>
      {useForMultiCards ? <>
        <button className="btn btn-close" onClick={onVoidTicket}><span>Void</span></button>
      </> :
        <CashierActionButton
          type='VOID'
          onClick={onVoidTicket}
        />
      }

      <ModalInputReasonVoid visible={visible} onClose={onClose} onVoid={handleVoidTicket} />
    </>
  );
};

export default CashierVoidTicket;
